/**
 * List of variants for Tag
 */
export var TagVariant;
(function (TagVariant) {
    /** @deprecated no tagVariant if default */
    TagVariant["DEFAULT"] = "TERTIARY";
    TagVariant["SUCCESS"] = "SUCCESS";
    TagVariant["SECONDARY"] = "SECONDARY";
    /** @deprecated use ERROR instead */
    TagVariant["DANGER"] = "DANGER";
    TagVariant["ERROR"] = "ERROR";
    TagVariant["WARNING"] = "WARNING";
})(TagVariant || (TagVariant = {}));
/**
 * List of variants background styles for Tag
 */
//# sourceMappingURL=TagEnum.js.map